// extracted by mini-css-extract-plugin
export default {"svg":"PulseCore_svg__ZoGG1"};